// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"PandaCalendar__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/PandaCalendar/PandaCalendar.scss
 ** module id = 928
 ** module chunks = 1
 **/